module.exports = __webpack_public_path__ + "media/גן.f722a9b3.mp3";